export default __webpack_public_path__ + "b4a8e4707ad52d1b5bc3cf973f52541a.svg";